import $ from "jquery";
import {ApckPortlet} from "../portlet";
import VueApexCharts from "vue-apexcharts";
import AjaxUtils from "../../../util/ajax_utils";

export const ApckPortletTrend = /*#__PURE__*/ ApckPortlet.extend({
    components: {
        'apexchart': VueApexCharts,
    },
    props: {
        ctype: {
            type: String,
            default: "trendportlet"
        },
        title: {
            type: String,
            default: "Vulnerability Trend"
        },
        size: {
            type: String,
            default: "full"
        },
        description: {
            type: String,
            default: "Shows a chart of the vulnerabilities trend by impact"
        },
        src: {
            type: String,
            default: "/trend"
        },
        defaultChartOptions: {
            type: Object,
            default: function () {
                return {
                    chart: {
                        stacked: true
                    },
                    subtitle: {
                        align: "center",
                        offsetY: 10
                    },
                    xaxis: {
                        type: "category",
                        categories: [],
                        forceNiceScale: true,
                        min: 0,
                        labels: {
                            show: false,
                            rotate: 0,
                        }
                    },
                    yaxis: {
                        tickAmount: 1,
                        forceNiceScale: true,
                        min: 0,
                        labels: {
                            formatter: function (val) {
                                return val.toFixed(0);
                            }
                        }
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        width: 1,
                        colors: ["#fff"]
                    },
                    fill: {
                        opacity: 1,
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: true
                            }
                        },
                        yaxis: {
                            lines: {
                                show: true
                            }
                        },
                    },
                    states: {
                        active: {
                            filter: {
                                type: 'none'
                            }
                        },
                        hover: {
                            filter: {
                                type: 'none',
                            }
                        },
                    },
                }
            }
        },
    },
    data: function () {
        return {
            series: null,
            loading: false,
            mostCommonChartOptions: $.extend(true, {}, this.defaultChartOptions),
            leastCommonChartOptions: $.extend(true, {}, this.defaultChartOptions),
            mostCommonChartSeries: [],
            leastCommonChartSeries: [],
            options: {
                size: {
                    choices: [
                        {"label": "Medium", "value": "md"},
                        {"label": "Large", "value": "lg"},
                        {"label": "Full width", "value": "full"},
                    ]
                },
                top: {
                    label: "Top",
                    type: "select",
                    default: 5,
                    choices: [
                        {label: "3", value: 3},
                        {label: "4", value: 4},
                        {label: "5", value: 5}
                    ]
                },
                time_window: {
                    label: "Time Window",
                    type: "select",
                    default: 365,
                    choices: [
                        {label: "One Month", value: 30},
                        {label: "Three Months", value: 90},
                        {label: "Six Months", value: 180},
                        {label: "One Year", value: 365},
                        {label: "Custom Range", value: 0}
                    ]
                },
                type: {
                    label: "Type",
                    type: "select",
                    default: "all",
                    choices: [
                        {label: "All", value: "all"},
                        {label: "Application", value: "app"},
                        {label: "Infrastructure", value: "infra"}
                    ]
                },
                vulnerability_impact: {
                    label: "Vulnerability Impact",
                    type: "select",
                    default: "all",
                    choices: [
                        {label: "All", value: "all"},
                        {label: "Critical", value: "critical"},
                        {label: "High", value: "high"},
                        {label: "Medium", value: "medium"},
                        {label: "Low", value: "low"}]
                }
            }

        };
    },
    watch: {
        computedURL: {
            handler: function() {
                this.refresh();
            }
        }
    },
    created() {
        const cmp = this;

        const impactMap = {
            'critical': '5.0-critical',
            'high': '4.0-high',
            'medium': '3.0-medium',
            'low': '2.0-low',
            'info': '1.0-info',
        }
        const categoryMap = {
            'all': 'all',
            'app': 'web_app',
            'infra': 'infra',
        }

        // register chart click actions
        const events = {
            dataPointSelection: function (event, chartContext, opts) {
                console.log(opts.w.config.xaxis.categories[opts.dataPointIndex])
                const selectedLabel = opts.w.config.xaxis.categories[opts.dataPointIndex];

                const filter_search = JSON.stringify({
                    filters: [{
                        field: 'title',
                        op: 'eq',
                        value: selectedLabel
                    }],
                    search: ''
                });
                const params = new URLSearchParams({
                    'filter_search': filter_search,
                    'status': 'all',
                    'category': categoryMap[cmp.options.type.value],
                });
                const impact = cmp.options.vulnerability_impact.value.toLowerCase();
                if (impact !== 'all') {
                    params.append('impact', impactMap[impact]);
                }

                const href = '/vulnerabilities?' + params.toString();
                window.open(href, '_blank').focus();
            }
        };

        this.mostCommonChartOptions.chart = this.mostCommonChartOptions.chart || {};
        this.mostCommonChartOptions.chart.events = {...this.mostCommonChartOptions.chart.events, ...events};

        this.leastCommonChartOptions.chart = this.leastCommonChartOptions.chart || {};
        this.leastCommonChartOptions.chart.events = {...this.leastCommonChartOptions.chart.events, ...events};
    },
    methods: {
        fetchSrc: function () {
            var cmp = this;
            var url = this.computedURL;
            if (url) {
                this.loading = true;
                AjaxUtils.ajax_get({
                    url: url,
                    success: function (data) {
                        cmp.mostCommonChartSeries = data.datasets.most;
                        cmp.leastCommonChartSeries = data.datasets.least;

                        cmp.mostCommonChartOptions['yaxis']['max'] = Math.max(...data.datasets.most.flatMap(
                            obj => obj.data)) + 5;
                        cmp.leastCommonChartOptions['yaxis']['max'] = Math.max(...data.datasets.least.flatMap(
                            obj => obj.data)) + 5;

                        cmp.mostCommonChartOptions['xaxis']['categories'] = data.categories.most;
                        cmp.leastCommonChartOptions['xaxis']['categories'] = data.categories.least;

                        cmp.mostCommonChartOptions['subtitle']['text'] = data.labels.most;
                        cmp.leastCommonChartOptions['subtitle']['text'] = data.labels.least;

                        cmp.mostCommonChartOptions['colors'] = data.colors;
                        cmp.leastCommonChartOptions['colors'] = data.colors;

                        cmp.$refs.mostChart.updateSeries(cmp.mostCommonChartSeries);
                        cmp.$refs.leastChart.updateSeries(cmp.leastCommonChartSeries);
                        cmp.$refs.mostChart.updateOptions(cmp.mostCommonChartOptions);
                        cmp.$refs.leastChart.updateOptions(cmp.leastCommonChartOptions);

                        cmp.loading = false;
                    },
                    fail: function () {
                        cmp.loading = false;
                    },
                    opts: {
                        dataType: 'json',
                        flash_form_errors: false,
                        flash_404_errors: false
                    }
                });
            }
        },
        refresh: function () {
            if (this.src) {
                this.loading = true;
                this.fetchSrc();
            }
        },
        reloadChart: function() {
            this.$refs.mostChart.refresh();
            this.$refs.leastChart.refresh();
        }
    },
    template: `
        <div :class="'portlet no-min-height col droppable draggable ' + colSize">
            <apck-panel no-padding :title="title" force-menu :draggable="Boolean(portal)">
                <template v-slot:menu="" v-if="portal && !hideMenu">
                    <apck-button
                        icon="fa-regular fa-gear"
                        :handler="settings"
                        class="title-button"
                        title="Settings"
                    />
                    <apck-button
                        icon="fa-regular fa-refresh"
                        :handler="refresh"
                        class="title-button"
                        title="Refresh"
                    />
                    <apck-button
                        :icon="['fa-regular', collapsed ? 'fa-chevron-down' : 'fa-chevron-up'].join(' ')"
                        :handler="collapse"
                        class="title-button"
                        :title="collapsed ? 'expand' : 'collapse'"
                    />
                    <apck-button
                        icon="fa-regular fa-close"
                        :handler="remove"
                        class="title-button"
                        title="Delete"
                    />
                </template>
    
                <div v-if="!collapsed" class="apck-flex-box" style="height: 300px; padding-bottom: 15px;">
                    <apexchart
                        ref="mostChart"
                        class="flex-col"
                        type="bar"
                        :options="mostCommonChartOptions"
                        :series="mostCommonChartSeries"
                        height="100%"
                    />
                    <apexchart
                        ref="leastChart"
                        class="flex-col"
                        type="bar"
                        :options="leastCommonChartOptions"
                        :series="leastCommonChartSeries"
                        height="100%"
                    />
                </div>
            </apck-panel>
        </div>
    `
});